import { render, staticRenderFns } from "./cooperationFrameworkProtocol.vue?vue&type=template&id=25f3bb96&scoped=true"
import script from "./cooperationFrameworkProtocol.vue?vue&type=script&lang=js"
export * from "./cooperationFrameworkProtocol.vue?vue&type=script&lang=js"
import style0 from "./cooperationFrameworkProtocol.vue?vue&type=style&index=0&id=25f3bb96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3bb96",
  null
  
)

export default component.exports